import { Injectable } from '@angular/core';
import { BackendService } from './backend.service';
import { Stat } from '../models/Stat';

export interface IFilteredStats {
  timeStamp: Date;
  exerciseTitle: String;
  category: String[];
}

@Injectable()
export class StatisticService {
  constructor(private backendService: BackendService) {}

  sendDidPlayVideoStatistic(stat: Stat) {
    return this.backendService.post('stats', [stat], 5).then((result) => {
      return result;
    });
  }

  getMyStatistic(): Promise<number[]> {
    return this.backendService.get('stats').then((stats) => {
      return stats as number[];
    });
  }

  async getMyStatisticForMonth(month: number): Promise<any> {
    return this.backendService.get(`stats/month/${month}`).then((stats) => {
      return stats;
    });
  }

  async getMyRealStatistic(): Promise<IFilteredStats[]> {
    return this.backendService.get('stats/achivement').then((stats) => {
      return stats as IFilteredStats[];
    });
  }

  getCompanyLeaderboard(month?: number, year?: number): Promise<any[]> {
    return this.backendService.get(`stats/company/leaderboard?month=${month || 0}&year=${year || 0}`).then((stats) => {
      return stats as any[];
    });
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/shared/services/statistic.service.ts